import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteTag, fetchTagList } from "../actions/tag";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";

const TagList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { tagList } = useSelector((state) => state.tagReducer);

  //breadcrumb
  const translateModule = "tag";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchTagList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/tag-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteTag(pageId));
  };

  const columnDefs = [
    {
      headerName: "Tag",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
    },
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 140,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchTagList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={tagList}
        columnDefs={columnDefs}
        buttonLink={`/tag-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="tag-list"
      />
    </Fragment>
  );
};

export default TagList;
